import { Shield, Zap, Crosshair } from "lucide-react";

const LOGO = "https://static.prod-images.emergentagent.com/jobs/3659a249-ae02-4d55-bcc3-719cf5f563d1/images/1314b3674cc56174078bf8182506b94ef2b5bddae411f45b53a645470891c1b2.png";

export const HeroBanner = () => {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            id="command-deck"
            data-testid="hero-banner"
            className="relative pt-32 pb-20 grid-bg border-b border-zinc-900 overflow-hidden"
        >
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-300/40 to-transparent animate-scan" />
            </div>

            <div className="max-w-[1600px] mx-auto px-6 md:px-8 relative">
                <div className="grid grid-cols-12 gap-6 lg:gap-10 items-center">
                    <div className="col-span-12 lg:col-span-7">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="w-8 h-px bg-gold-300" />
                            <span className="label-tactical">CLASSIFIED · OPERATIONAL DOCTRINE</span>
                        </div>

                        <h1
                            data-testid="hero-title"
                            className="text-4xl sm:text-5xl lg:text-7xl font-black uppercase tracking-tighter text-white leading-[0.92]"
                        >
                            From <span className="text-gold-300">MOS</span> to
                            <br />
                            <span className="text-gold-300">Armada</span>.
                            <br />
                            From Order to <span className="text-gold-300">Sovereignty</span>.
                        </h1>

                        <div className="gold-divider mt-8 mb-6 max-w-md" />

                        <p className="text-zinc-300 text-base lg:text-lg leading-relaxed max-w-2xl">
                            The full-spectrum DoD lifecycle hub. Crosswalk every job code across
                            all six branches into <span className="text-gold-300 font-bold">EIGOO business hulls</span>.
                            Track GI Bill, TA, CA caps. Synthesize TAP documents. Run terminal leave
                            with surgical precision.
                        </p>

                        <div className="flex flex-wrap gap-3 mt-8">
                            <button
                                data-testid="hero-cta-crosswalk"
                                onClick={() => scrollTo("mos-crosswalk")}
                                className="group bg-gold-300 hover:bg-gold-200 text-black px-6 py-3.5 uppercase tracking-[0.2em] text-xs font-black border border-gold-300 transition-all flex items-center gap-3"
                            >
                                <Crosshair className="w-4 h-4" />
                                Run Crosswalk
                                <span className="w-6 h-px bg-black group-hover:w-10 transition-all" />
                            </button>
                            <button
                                data-testid="hero-cta-sovereign"
                                onClick={() => scrollTo("sovereign-pace")}
                                className="border border-zinc-700 hover:border-gold-300 text-zinc-300 hover:text-gold-300 px-6 py-3.5 uppercase tracking-[0.2em] text-xs font-bold transition-all flex items-center gap-3"
                            >
                                <Zap className="w-4 h-4" />
                                Engage Pace
                            </button>
                        </div>

                        <div className="grid grid-cols-3 mt-12 max-w-2xl border-t border-zinc-800/80">
                            <Stat label="Branches" value="6" suffix="DoD" />
                            <Stat label="Exoskeleton" value="90" suffix="% AUTO" gold />
                            <Stat label="Strategic" value="10" suffix="% HUMAN" />
                        </div>
                    </div>

                    <div className="col-span-12 lg:col-span-5 relative">
                        <div className="relative aspect-square max-w-md mx-auto corner-bracket p-6 bg-black/60">
                            <div className="absolute inset-0 grid-bg opacity-50" />
                            <img
                                src={LOGO}
                                alt="Vanguard Command Crest"
                                className="relative w-full h-full object-contain animate-pulse-gold"
                                data-testid="hero-crest"
                            />
                            <div className="absolute -top-3 left-6 bg-black px-2">
                                <span className="label-tactical">CREST · 0001</span>
                            </div>
                            <div className="absolute -bottom-3 right-6 bg-black px-2">
                                <span className="label-tactical">VANGUARD CMD</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const Stat = ({ label, value, suffix, gold }) => (
    <div className="border-r last:border-r-0 border-zinc-800/80 px-4 py-5">
        <div className="label-tactical">{label}</div>
        <div className="mt-2 flex items-baseline gap-2">
            <div
                className={`text-3xl lg:text-4xl font-black tracking-tight ${
                    gold ? "text-gold-300" : "text-white"
                }`}
            >
                {value}
            </div>
            <div className="badge-tier text-zinc-500">{suffix}</div>
        </div>
    </div>
);

export default HeroBanner;
